import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

import general from './store/general'
import mainMenuStore from './mainMenuSrc/store/mainMenuStore'

// Create a new store
const store = new Vuex.Store({
  modules: {general, mainMenuStore}
})

export default store
